import { WebSocketState } from './web-socket-state';

export enum WebSocketErrorType {
	CONNECTION_CLOSED = 'sockets.error.connectionClosed',
	CONNECTION_ERROR = 'sockets.error.connectionError',
	CONNECTION_RECONNECTING = 'sockets.error.connectionReconnecting',
}

export interface WebSocketError {
	webSocketState: WebSocketState;
	error: Error;
	errorType?: WebSocketErrorType;
}
